( function( root, factory ) {
	let api = factory( root );

	if ( typeof module === 'object' && module.exports ) {
		module.exports = api;
	}

	if ( root ) {
		root.EnduroShieldCartUpsell = api;
	}
}( typeof window !== 'undefined' ? window : null, function( root ) {
	'use strict';
	let cartMutationInFlight = false;

	function buildCartUrl( endpoint, routesRoot ) {
		let pathRoot = routesRoot;
		if ( ! pathRoot && root && root.Shopify && root.Shopify.routes ) {
			pathRoot = root.Shopify.routes.root;
		}
		pathRoot = pathRoot || '/';
		if ( pathRoot.charAt( pathRoot.length - 1 ) !== '/' ) {
			pathRoot += '/';
		}
		return pathRoot + endpoint.replace( /^\//, '' );
	}

	function calculateEnduroShield( lines ) {
		let eligibleMillimetres = 0;
		let existingServiceQuantity = 0;
		let valid = true;

		lines.forEach( function( line ) {
			let quantity = Number( line.quantity );

			if ( line.quantity === '' || ! Number.isInteger( quantity ) || quantity < 0 ) {
				valid = false;
				return;
			}

			if ( line.service ) {
				existingServiceQuantity += quantity;
			} else if ( line.eligible ) {
				let widthMm = Number( line.widthMm );

				if ( line.widthMm === '' || ! Number.isFinite( widthMm ) || widthMm <= 0 ) {
					valid = false;
					return;
				}

				eligibleMillimetres += widthMm * quantity;
			}
		} );

		if ( ! valid ) {
			return {
				valid: false,
				eligibleMetres: 0,
				requiredQuantity: 0,
				existingServiceQuantity: 0,
				missingQuantity: 0
			};
		}

		let eligibleMetres = eligibleMillimetres / 1000;
		let requiredQuantity = Math.ceil( eligibleMetres );

		return {
			valid: true,
			eligibleMetres: eligibleMetres,
			requiredQuantity: requiredQuantity,
			existingServiceQuantity: existingServiceQuantity,
			missingQuantity: Math.max( requiredQuantity - existingServiceQuantity, 0 )
		};
	}

	function readCartLines( scope ) {
		return Array.prototype.map.call( scope.querySelectorAll( '[data-enduroshield-line]' ), function( line ) {
			let quantityInput = line.querySelector( '.quantity-selector input' );

			return {
				key: line.getAttribute( 'data-enduroshield-key' ),
				eligible: line.getAttribute( 'data-enduroshield-eligible' ) === 'true',
				widthMm: line.getAttribute( 'data-enduroshield-width-mm' ),
				quantity: quantityInput ? quantityInput.value : line.getAttribute( 'data-enduroshield-quantity' ),
				service: line.getAttribute( 'data-enduroshield-service' ) === 'true'
			};
		} );
	}

	function mergeAuthoritativeCartLines( lines, cartItems ) {
		if ( ! Array.isArray( cartItems ) || lines.length !== cartItems.length ) {
			return null;
		}

		let cartItemsByKey = {};
		let validKeys = true;
		cartItems.forEach( function( item ) {
			if ( ! validKeys ) {
				return;
			}
			if ( ! item.key || Object.prototype.hasOwnProperty.call( cartItemsByKey, item.key ) ) {
				validKeys = false;
				return;
			}
			cartItemsByKey[ item.key ] = item;
		} );

		if ( ! validKeys ) {
			return null;
		}

		let merged = [];
		for ( let index = 0; index < lines.length; index += 1 ) {
			let line = lines[ index ];
			let item = cartItemsByKey[ line.key ];
			if ( ! item ) {
				return null;
			}
			merged.push( {
				key: line.key,
				eligible: line.eligible,
				widthMm: line.widthMm,
				quantity: item.quantity,
				service: line.service
			} );
		}

		return merged;
	}

	function replaceTemplateValue( template, token, value ) {
		return template.split( token ).join( value );
	}

	function recalculate( rootElement ) {
		if ( cartMutationInFlight ) {
			return;
		}
		let root = rootElement || document;
		let upsells = root.querySelectorAll( '[data-enduroshield-upsell]' );

		Array.prototype.forEach.call( upsells, function( upsell ) {
			let scope = upsell.closest( '.form-cart' );
			let button = upsell.querySelector( '[data-enduroshield-add]' );
			let message = upsell.querySelector( '[data-enduroshield-message]' );
			let status = upsell.querySelector( '[data-enduroshield-status]' );
			let error = upsell.querySelector( '[data-enduroshield-error]' );

			if ( ! scope || ! button ) {
				upsell.hidden = true;
				return;
			}

			let result = calculateEnduroShield( readCartLines( scope ) );
			button.disabled = false;
			button.removeAttribute( 'aria-busy' );
			error.hidden = true;
			error.textContent = '';
			status.textContent = '';

			if ( ! result.valid ) {
				upsell.hidden = false;
				button.hidden = true;
				error.hidden = false;
				error.textContent = upsell.getAttribute( 'data-invalid-message' );
				return;
			}

			if ( result.missingQuantity === 0 ) {
				upsell.hidden = true;
				return;
			}

			let metres = Number( result.eligibleMetres.toFixed( 3 ) ).toString();
			let recommendation = replaceTemplateValue( upsell.getAttribute( 'data-message-template' ), '__METRES__', metres );
			recommendation = replaceTemplateValue( recommendation, '__QUANTITY__', result.missingQuantity );

			upsell.hidden = false;
			button.hidden = false;
			button.setAttribute( 'data-enduroshield-quantity', result.missingQuantity );
			button.textContent = replaceTemplateValue( upsell.getAttribute( 'data-button-template' ), '__QUANTITY__', result.missingQuantity );
			message.textContent = recommendation;
		} );
	}

	function fetchJson( url, options ) {
		return fetch( url, options ).then( function( response ) {
			if ( ! response.ok ) {
				return response.json().catch( function() {
					return {};
				} ).then( function( body ) {
					throw new Error( body.description || 'Request failed' );
				} );
			}

			return response.json();
		} );
	}

	function isValidCart( cart ) {
		return !! cart && Array.isArray( cart.items ) && cart.items.every( function( item ) {
			let variantId = Number( item.variant_id || item.id );
			let quantity = Number( item.quantity );
			return !! item.key && Number.isInteger( variantId ) && variantId > 0 && Number.isInteger( quantity ) && quantity >= 0;
		} );
	}

	function cartVariantQuantity( cart, variantId ) {
		if ( ! isValidCart( cart ) ) {
			return null;
		}

		return cart.items.reduce( function( total, item ) {
			let itemVariantId = Number( item.variant_id || item.id );
			return itemVariantId === variantId ? total + Number( item.quantity || 0 ) : total;
		}, 0 );
	}

	function syncRenderedCartLines( scope, cart ) {
		if ( ! scope || ! isValidCart( cart ) ) {
			return false;
		}

		let itemsByKey = {};
		for ( let index = 0; index < cart.items.length; index += 1 ) {
			let item = cart.items[ index ];
			if ( Object.prototype.hasOwnProperty.call( itemsByKey, item.key ) ) {
				return false;
			}
			itemsByKey[ item.key ] = item;
		}

		let lines = scope.querySelectorAll( '[data-enduroshield-line]' );
		if ( lines.length !== cart.items.length ) {
			return false;
		}

		for ( let lineIndex = 0; lineIndex < lines.length; lineIndex += 1 ) {
			let line = lines[ lineIndex ];
			let item = itemsByKey[ line.getAttribute( 'data-enduroshield-key' ) ];
			let input = line.querySelector( '.quantity-selector input' );
			if ( ! item ) {
				return false;
			}
			line.setAttribute( 'data-enduroshield-quantity', item.quantity );
			if ( input ) {
				input.value = item.quantity;
			}
		}

		return true;
	}

	function buildServiceUpdate( variantId, missingQuantity, cartBefore ) {
		variantId = Number( variantId );
		missingQuantity = Number( missingQuantity );
		if ( ! Number.isInteger( variantId ) || variantId <= 0 || ! Number.isInteger( missingQuantity ) || missingQuantity <= 0 ) {
			return null;
		}

		let items = cartBefore && Array.isArray( cartBefore.items ) ? cartBefore.items : [];
		let serviceItems = items.filter( function( item ) {
			return Number( item.variant_id || item.id ) === variantId;
		} );
		let existingTotal = 0;
		for ( let i = 0; i < serviceItems.length; i++ ) {
			let itemQuantity = Number( serviceItems[ i ].quantity );
			if ( ! Number.isInteger( itemQuantity ) || itemQuantity < 0 ) {
				return null;
			}
			existingTotal += itemQuantity;
		}

		let updateKey = String( variantId );
		let updateQuantity = missingQuantity;
		if ( serviceItems.length ) {
			let keys = serviceItems.map( function( item ) {
				return String( item.key || '' );
			} );
			if ( keys.some( function( key ) { return ! key; } ) || new Set( keys ).size !== keys.length ) {
				return null;
			}
			updateKey = keys[ 0 ];
			updateQuantity = Number( serviceItems[ 0 ].quantity ) + missingQuantity;
		}

		let updates = {};
		updates[ updateKey ] = updateQuantity;
		return {
			updates: updates,
			expectedTotal: existingTotal + missingQuantity
		};
	}

	function addServiceAndReadCart( variantId, quantity, requestJson, cartBefore ) {
		let request = requestJson || fetchJson;
		let update = buildServiceUpdate( variantId, quantity, cartBefore );
		if ( ! update ) {
			return Promise.reject( new Error( 'Invalid EnduroShield service update' ) );
		}

		return request( buildCartUrl( 'cart/update.js' ), {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify( { updates: update.updates } )
		} ).then( function() {
			return request( buildCartUrl( 'cart.js' ), {
				headers: {
					'Accept': 'application/json'
				}
			} ).then( function( cart ) {
				if ( ! isValidCart( cart ) ) {
					return {
						added: true,
						cart: null,
						readBackFailed: true
					};
				}
				return {
					added: true,
					cart: cart,
					readBackFailed: false
				};
			}, function() {
				return {
					added: true,
					cart: null,
					readBackFailed: true
				};
			} );
		}, function( addError ) {
			if ( ! cartBefore ) {
				throw addError;
			}

			return request( buildCartUrl( 'cart.js' ), {
				headers: {
					'Accept': 'application/json'
				}
			} ).then( function( cart ) {
				if ( ! isValidCart( cart ) ) {
					return {
						added: null,
						cart: null,
						reconciliationFailed: true
					};
				}
				if ( cartVariantQuantity( cart, variantId ) >= update.expectedTotal ) {
					return {
						added: true,
						cart: cart,
						readBackFailed: false,
						reconciled: true
					};
				}
				throw addError;
			}, function() {
				return {
					added: null,
					cart: null,
					reconciliationFailed: true
				};
			} );
		} );
	}

	function setUpsellsBusy( scope, messageAttribute ) {
		if ( ! scope ) {
			return;
		}

		Array.prototype.forEach.call( scope.querySelectorAll( '[data-enduroshield-upsell]' ), function( upsell ) {
			let button = upsell.querySelector( '[data-enduroshield-add]' );
			let status = upsell.querySelector( '[data-enduroshield-status]' );

			upsell.hidden = false;
			if ( button ) {
				button.disabled = true;
				button.hidden = true;
				button.setAttribute( 'aria-busy', 'true' );
			}
			if ( status ) {
				status.textContent = upsell.getAttribute( messageAttribute ) || '';
			}
		} );
	}

	function acquireCartMutationLock( scope, messageAttribute ) {
		if ( cartMutationInFlight ) {
			return false;
		}
		cartMutationInFlight = true;
		setUpsellsBusy( scope, messageAttribute );
		return true;
	}

	function releaseCartMutationLock() {
		cartMutationInFlight = false;
	}

	function blockCartInteractionIfBusy( event ) {
		if ( ! cartMutationInFlight || ! event.target || typeof event.target.closest !== 'function' || ! event.target.closest( '.form-cart' ) ) {
			return false;
		}
		event.preventDefault();
		if ( typeof event.stopImmediatePropagation === 'function' ) {
			event.stopImmediatePropagation();
		}
		return true;
	}

	function showAddedState( scope, messageAttribute ) {
		if ( ! scope ) {
			return;
		}

		Array.prototype.forEach.call( scope.querySelectorAll( '[data-enduroshield-upsell]' ), function( upsell ) {
			let button = upsell.querySelector( '[data-enduroshield-add]' );
			let message = upsell.querySelector( '[data-enduroshield-message]' );
			let status = upsell.querySelector( '[data-enduroshield-status]' );
			let error = upsell.querySelector( '[data-enduroshield-error]' );

			upsell.hidden = false;
			if ( button ) {
				button.disabled = true;
				button.hidden = true;
				button.removeAttribute( 'aria-busy' );
			}
			if ( message ) {
				message.textContent = '';
			}
			if ( status ) {
				let announcement = upsell.getAttribute( messageAttribute ) || '';
				status.textContent = '';
				setTimeout( function() {
					status.textContent = announcement;
					if ( typeof status.focus === 'function' ) {
						status.focus();
					}
				}, 0 );
			}
			if ( error ) {
				error.hidden = true;
				error.textContent = '';
			}
		} );
	}

	function refreshRenderedCart( surfaceSelector ) {
		return fetch( buildCartUrl( 'cart' ), {
			headers: {
				'Accept': 'text/html'
			}
		} ).then( function( response ) {
			if ( ! response.ok ) {
				throw new Error( 'Cart refresh failed' );
			}

			return response.text();
		} ).then( function( cartHtml ) {
			let parsedHtml = document.createElement( 'html' );
			parsedHtml.innerHTML = cartHtml;
			let selector = surfaceSelector || '#cart-page-content .form-cart';
			let sourceScope = parsedHtml.querySelector( selector );
			let targetScope = document.querySelector( selector );

			if ( ! sourceScope || ! targetScope ) {
				throw new Error( 'Cart surface missing' );
			}

			targetScope.innerHTML = sourceScope.innerHTML;
			return targetScope;
		} );
	}

	function addRecommendedService( button ) {
		if ( button.disabled ) {
			return;
		}

		let upsell = button.closest( '[data-enduroshield-upsell]' );
		let scope = upsell.closest( '.form-cart' );
		let surfaceSelector = button.closest( '#cart-ajax' ) ? '#cart-ajax .form-cart' : '#cart-page-content .form-cart';
		let status = upsell.querySelector( '[data-enduroshield-status]' );
		let error = upsell.querySelector( '[data-enduroshield-error]' );
		let variantId = Number( button.getAttribute( 'data-enduroshield-variant-id' ) );
		let quantity = Number( button.getAttribute( 'data-enduroshield-quantity' ) );

		if ( ! Number.isInteger( variantId ) || ! Number.isInteger( quantity ) || quantity <= 0 ) {
			return;
		}

		if ( ! acquireCartMutationLock( document, 'data-adding-message' ) ) {
			return;
		}

		fetchJson( buildCartUrl( 'cart.js' ), {
			headers: {
				'Accept': 'application/json'
			}
		} ).then( function( currentCart ) {
			let authoritativeLines = mergeAuthoritativeCartLines( readCartLines( scope ), currentCart.items );
			let currentResult = authoritativeLines ? calculateEnduroShield( authoritativeLines ) : null;

			if ( ! currentResult || ! currentResult.valid || currentResult.missingQuantity !== quantity ) {
				showAddedState( scope, 'data-cart-changed-message' );
				return null;
			}

			return addServiceAndReadCart( variantId, quantity, null, currentCart );
		}, function() {
			showAddedState( scope, 'data-cart-changed-message' );
			return null;
		} ).then( function( result ) {
			if ( ! result ) {
				return;
			}
			if ( result.added === null ) {
				showAddedState( scope, 'data-add-unknown-message' );
				return;
			}
			if ( ! result.cart ) {
				showAddedState( scope, 'data-added-refresh-message' );
				return;
			}

			let cartCount = document.querySelector( '#cart-ajax-trigger .cart-items-number' );
			if ( cartCount ) {
				cartCount.textContent = result.cart.item_count;
			}

			let renderedCartConfirmed = syncRenderedCartLines( scope, result.cart );
			if ( renderedCartConfirmed ) {
				releaseCartMutationLock();
				recalculate( scope );
				showAddedState( scope, 'data-added-message' );
			}

			return refreshRenderedCart( surfaceSelector ).then( function( freshScope ) {
				if ( ! renderedCartConfirmed ) {
					releaseCartMutationLock();
				}
				recalculate( freshScope );
				showAddedState( freshScope, 'data-added-message' );
			}, function() {
				if ( ! renderedCartConfirmed ) {
					releaseCartMutationLock();
					showAddedState( scope, 'data-added-refresh-message' );
				}
			} );
		}, function() {
			releaseCartMutationLock();
			recalculate();
			button.disabled = false;
			button.removeAttribute( 'aria-busy' );
			status.textContent = '';
			error.hidden = false;
			error.textContent = upsell.getAttribute( 'data-add-error-message' );
			if ( typeof button.focus === 'function' ) {
				button.focus();
			}
		} );
	}

	function markUncommittedCart( target ) {
		if ( target.closest( '#cart-ajax' ) ) {
			return;
		}

		setUpsellsBusy( target.closest( '.form-cart' ), 'data-update-cart-message' );
	}

	if ( typeof document !== 'undefined' ) {
		document.addEventListener( 'DOMContentLoaded', function() {
			recalculate();
		} );

		document.addEventListener( 'click', function( event ) {
			if ( blockCartInteractionIfBusy( event ) ) {
				return;
			}
			let button = event.target.closest( '[data-enduroshield-add]' );
			if ( button ) {
				event.preventDefault();
				addRecommendedService( button );
				return;
			}

			if ( event.target.closest( '.quantity-handle' ) ) {
				setTimeout( function() {
					markUncommittedCart( event.target );
				}, 0 );
			}
		} );

		document.addEventListener( 'input', function( event ) {
			if ( event.target.closest( '.quantity-selector input' ) ) {
				markUncommittedCart( event.target );
			}
		} );

		document.addEventListener( 'submit', function( event ) {
			blockCartInteractionIfBusy( event );
		} );
	}

	return {
		acquireCartMutationLock: acquireCartMutationLock,
		addServiceAndReadCart: addServiceAndReadCart,
		blockCartInteractionIfBusy: blockCartInteractionIfBusy,
		buildCartUrl: buildCartUrl,
		buildServiceUpdate: buildServiceUpdate,
		calculateEnduroShield: calculateEnduroShield,
		mergeAuthoritativeCartLines: mergeAuthoritativeCartLines,
		recalculate: recalculate,
		refreshRenderedCart: refreshRenderedCart,
		releaseCartMutationLock: releaseCartMutationLock,
		setUpsellsBusy: setUpsellsBusy,
		showAddedState: showAddedState,
		syncRenderedCartLines: syncRenderedCartLines
	};
} ) );
